module.exports = {
      id: "authoranchor-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#authoranchor",
      toString: function () {
        return this.url;
      }
    }